// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q2RMM","index":"styles_index__3BNz7"};